import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import SectionSection from "../../../shared/Section";
import axios from "axios";
import { loadModules } from "esri-loader";

class FacilitiesMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      reportName: "ArcGIS Facility Map Test",
      gridName: "",
      error: "",
      results: [],
      facilitiesLayer: [],
      parameters: {
        keyword: {
          id: "keyword",
          label: "Keyword",
          type: "text",
        },
      },
      apiString: "api/v1/hwts/search/facility/advanced?",
    };
    this.mapRef = React.createRef();
  }

  callAPI() {
    this.setState({
      isFetching: true,
      error: "",
    });
    axios
      .get(this.state.apiString, {
        params: this.state.params,
      })
      .then((results) => {
        this.setState(
          {
            results: results.data,
          },
          () => {
            this.state.map.removeAll();
            if (results.data.length > 0) {
              this.createFacilities();
            } else {
              this.setState({
                isFetching: false,
              });
            }
          }
        );
      })
      .catch((error) => {
        this.setState({
          error: error.response,
          isFetching: false,
        });
      });
  }

  createFacilities = () => {
    loadModules(["esri/layers/FeatureLayer", "esri/layers/support/Field"])
      .then(([FeatureLayer, Field]) => {
        const facilityRenderer = {
          type: "simple",
          symbol: {
            type: "simple-marker",
            size: 8,
            //color:[0, 255, 255],
            color: [0, 255, 255],
            outline: null,
          },
        };

        const fields = [
          new Field({
            name: "ObjectID",
            alias: "ObjectID",
            type: "oid",
          }),
          new Field({
            name: "FacName",
            alias: "FacName",
            type: "string",
          }),
          new Field({
            name: "EpaId",
            alias: "EpaId",
            type: "string",
          }),
        ];

        const results = this.state.results.filter((item) => {
          return item.DDLongitude <= -113 && item.DDLongitude >= -125;
        });
        //&& (item.DDLatitude <= 43 && item.DDLatitude >= 31)

        const facilities = results.map((data, idx) => {
          return {
            geometry: {
              type: "point",
              x: data.DDLongitude,
              y: data.DDLatitude,
            },
            attributes: {
              ObjectID: idx,
              FacName: data.FacName,
              EpaId: data.EpaId,
            },
          };
        });

        var facilitiesPopup = {
          title: "<b>({EpaId}) - {FacName}</b>",
          // "content": "<b>{FacName}</b>"
        };

        const facilityLayer = new FeatureLayer({
          title: "facility layer",
          source: facilities,
          fields: fields,
          ObjectIDField: "ObjectID",
          renderer: facilityRenderer,
          popupTemplate: facilitiesPopup,
        });

        facilityLayer.on("layerview-create", (e) => {
          this.setState({
            isFetching: false,
          });
          facilityLayer.queryExtent().then((response) => {
            if (response.count === 1) {
              this.view.goTo({
                target: facilities[0],
                zoom: 20,
              });
            } else {
              this.view.goTo(response.extent.expand(1.1));
            }
          });
        });

        this.setState(
          {
            facilityLayer: facilityLayer,
          },
          () => {
            this.state.map.removeAll();
            this.state.map.add(this.state.facilityLayer);
          }
        );
      })
      .catch((err) => console.error(err));
  };

  createMap = () => {
    // lazy load the required ArcGIS API for JavaScript modules and CSS
    loadModules(
      [
        "esri/WebMap",
        "esri/views/MapView",
        "esri/Basemap",
        "esri/layers/FeatureLayer",
        "esri/renderers/DotDensityRenderer",
        "esri/widgets/Legend",
        "esri/webmap/Bookmark",
        "esri/widgets/Bookmarks",
        "esri/widgets/Expand",
        "esri/widgets/LayerList",
        "esri/widgets/Slider",
        "esri/widgets/ScaleBar",
        "esri/geometry/Extent",
      ],
      { css: true }
    ).then(
      ([
        WebMap,
        MapView,
        Basemap,
        FeatureLayer,
        DotDensityRenderer,
        Legend,
        Bookmark,
        Bookmarks,
        Expand,
        LayerList,
        Slider,
        ScaleBar,
        Extent,
      ]) => {
        const map = new WebMap({
          portalItem: {
            id: "da83595b291349b79c7e56e5fabc5fde",
          },
          //basemap: Basemap.fromId("streets-night-vector"),
          center: [-122.057281, 38.250313],
          zoom: 10,
        });

        map.center = [-122.057281, 38.250313];

        this.setState({
          map: map,
        });

        this.view = new MapView({
          container: this.mapRef.current,
          map: this.state.map,
          center: [-122.057281, 38.250313],
          zoom: 8,
          highlightOptions: {
            fillOpacity: 0,
            color: [50, 50, 50],
          },
          popup: {
            dockEnabled: true,
            dockOptions: {
              position: "top-right",
              breakpoint: false,
            },
          },
          constraints: {
            maxScale: 35000,
            minScale: 10000000,
          },
        });

        var legend = new Legend({
          view: this.view,
          container: "legendDiv",
        });
        var legendContainer = document.getElementById("legendDiv");

        // this.view.ui.add([
        //     // new Expand({
        //     //     view: this.view,
        //     //     content: new Legend({ view: this.view }),
        //     //     group: "top-left",
        //     //     expanded: true
        //     // }),
        //     new Expand({
        //         view: this.view,
        //         content: document.getElementById("controlDiv"),
        //         group: "top-left",
        //         expanded: true,
        //         expandIconClass: "esri-icon-layer-list"
        //     }),
        //     new Expand({
        //         view: this.view,
        //         expandIconClass: "esri-icon-filter",
        //         content: document.getElementById("sliderDiv"),
        //         group: "top-left"
        //     }),
        // ], "top-left");

        var scaleBar = new ScaleBar({
          view: this.view,
        });

        var bookmarks = new Bookmarks({
          view: this.view,
          editingEnabled: true,
          bookmarks: [],
        });

        var sacramentoBookmark = new Bookmark({
          name: "Sacramento",
          extent: new Extent({
            xmin: -121.381607,
            xmax: -121.592883,
            ymin: 38.538727,
            ymax: 38.619837,
          }),
        });

        var sanFranciscoBookmark = new Bookmark({
          name: "San Francisco",
          extent: new Extent({
            xmin: -122.038817,
            xmax: -122.752494,
            ymin: 37.615527,
            ymax: 37.880657,
          }),
        });

        var losAngelesBookmark = new Bookmark({
          name: "Los Angeles",
          extent: new Extent({
            xmin: -117.268015,
            xmax: -118.80107,
            ymin: 33.702436,
            ymax: 34.24332,
          }),
        });

        bookmarks.bookmarks.push(sacramentoBookmark);
        bookmarks.bookmarks.push(sanFranciscoBookmark);
        bookmarks.bookmarks.push(losAngelesBookmark);

        this.view.ui.add(
          new Expand({
            view: this.view,
            //content: new Bookmarks({ view: this.view }),
            content: bookmarks,
            group: "bottom-right",
            expanded: false,
          }),
          "bottom-right"
        );

        this.view.ui.add(scaleBar, "bottom-right");
      }
    );
    this.setState({
      view: this.view,
    });
  };
  componentDidMount() {
    document.title = this.state.reportName;
    // this.createFacilities();
    this.createMap();
  }

  componentDidUpdate() {
    // this.createFacilities();
  }

  componentWillUnmount() {
    if (this.view) {
      // destroy the map view
      this.view.container = null;
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.callAPI();
  };

  render() {
    // this.createMap();
    const handleChange = (e) => {
      e.persist();
      const { name, value } = e.target;
      this.setState(() => ({
        ...this.state,
        parameters: {
          ...this.state.parameters,
          [name]: {
            ...this.state.parameters[name],
            value: value,
          },
        },
        params: {
          ...this.state.params,
          [name]: value,
        },
      }));
    };
    const keywordInput = Object.keys(this.state.parameters).map((key) => {
      return key == "keyword" ? (
        <div className="">
          <span>{this.state.parameters[key].label}</span>
          <div>
            <input
              className="text-filter"
              type="text"
              name={this.state.parameters[key].id}
              value={this.state.parameters[key].value}
              onChange={handleChange}
              style={{ width: "90%", height: "40px", fontSize: "2rem" }}
            />
          </div>
        </div>
      ) : null;
    });

    return (
      <div style={{ height: "100%" }}>
        <SectionSection
          title={
            <Link to="/reports" style={{ color: "white" }}>
              {this.state.reportName}
            </Link>
          }
          type={"standout"}
        />
        <div
          className="container m-t-sm m-b-sm"
          style={{
            position: "relative",
            display: "grid",
            gridTemplateColumns: "1fr",
            gridTemplateRows: "1fr",
            minHeight: "62px",
          }}
        >
          {this.state.isFetching === false ? (
            <form onSubmit={this.handleSubmit}>
              {keywordInput}
              <input
                type="submit"
                value="Submit"
                style={{
                  height: "fit-content",
                  width: "100px",
                  height: "40px",
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                }}
              ></input>
            </form>
          ) : (
            <div
              className="animated-background-map m-b-sm"
              style={{ height: "40px" }}
            />
          )}
        </div>
        {/* <div className="container m-t-sm">
                    {this.state.isFetching === true &&
                        <div
                            className="animated-background m-b-sm"
                            style={{ height: '25px' }}
                        />
                    }
                    {this.state.error != "" &&
                        <div className="m-t-sm m-b-sm" style={{ color: 'red' }}>
                            {this.state.error.data}
                        </div>
                    }
                </div> */}
        <div className="" style={{ position: "relative", height: "100%" }}>
          <div className="webmap-reports" ref={this.mapRef} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(FacilitiesMap);
